import { RequestStatus } from 'clickNgo/configs/service/common'

import { IP360PartnerFlagsState } from './models/state'

export const initialState: IP360PartnerFlagsState = {
  data: [],
  requestStatus: RequestStatus.NONE,
}
